export const CategoryOptionsMap = {
  'Pre-Rolls': {
    key: 'pre-rolls',
    label: 'Pre-Rolls',
    value: 'Pre-Rolls',
  },
  Vaporizers: {
    key: 'vaporizers',
    label: 'Vaporizers',
    value: 'Vaporizers',
  },
  Concentrate: {
    key: 'concentrates',
    label: 'Concentrates',
    value: 'Concentrate',
  },
  Edible: {
    key: 'edibles',
    label: 'Edibles',
    value: 'Edible',
  },
  // This fixture's typed consumer has referenced `CategoryOptionsMap.Oral` for years,
  // but the JS object never actually defined it (so that test silently received
  // `undefined`). Match the consuming test's intended Oral option instead of hiding the gap.
  Oral: {
    key: 'oral',
    label: 'Oral',
    value: 'Oral',
  },
  Topicals: {
    key: 'topicals',
    label: 'Topicals',
    value: 'Topicals',
  },
  Tincture: {
    key: 'tinctures',
    label: 'Tinctures',
    value: 'Tincture',
  },
  Flower: {
    key: 'flower',
    label: 'Flower',
    value: 'Flower',
  },
  Accessories: {
    key: 'accessories',
    label: 'Accessories',
    value: 'Accessories',
  },
  CBD: {
    key: 'cbd',
    label: 'CBD',
    value: 'CBD',
  },
  Seeds: {
    key: 'seeds',
    label: 'Seeds',
    value: 'Seeds',
  },
  Clones: {
    key: 'clones',
    label: 'Clones',
    value: 'Clones',
  },
  Apparel: {
    key: 'apparel',
    label: 'Apparel',
    value: 'Apparel',
  },
  'N/A': {
    key: 'n/a',
    label: 'N/A',
    value: 'N/A',
  },
};
